<template>
  <section>
    <b-field label="Selecione o Ano">
      <b-select v-model="ano">
        <option
          v-for="(ano, index) in this.$store.getters['associacao/getAssociacao'].anos_plataforma"
          :value="ano"
          :key="index"
        >{{ano}}</option>
      </b-select>
    </b-field>

    <b-table
      :data="isEmpty ? [] : this.$store.getters['associacao/getAssociacao'].socios.ativos"
      ref="table"
      paginated
      per-page="15"
      detailed
      detail-key="_id"
      default-sort="nome"
      @details-open="(row, index) => $toast.open(`Expandido ${row.nome}`)"
    >
      <template slot-scope="props">
        <b-table-column field="id" label="Nº" width="40" numeric>{{ props.index+1 }}</b-table-column>

        <b-table-column field="nome" label="Nome" sortable>
          <template>
            <a @click="toggle(props.row)">{{ props.row.nome }}</a>
          </template>
        </b-table-column>

        <b-table-column field="status" label="Status" centered sortable>
          <span v-if="verifyStatusPgto(props.row)" class="tag is-success">Em Dias</span>
          <span v-else class="tag is-danger">Em Débito</span>
        </b-table-column>

        <b-table-column
          field="date"
          label="Data de Ingresso"
          sortable
          centered
        >{{ new Date(props.row.associacoes[`${idAssociacao}`].data_ingresso).toLocaleDateString() }}</b-table-column>

        <b-table-column v-if="!props.row.telefone_celular" label="Contato" centered>Não Informado</b-table-column>
        <b-table-column v-else label="Contato" centered>{{ props.row.telefone_celular }}</b-table-column>
      </template>

      <template slot="detail" slot-scope="props">
        <nav class="level">
          <div class="level-item has-text-centered">
            <div>
              <a
                class="button is-small"
                :class="generateClassColorStyle(props.row,'jan')"
                @click="gerMensalidade(props.row,'jan')"
              >JAN</a>
              <a
                class="button is-small"
                :class="generateClassColorStyle(props.row,'fev')"
                @click="gerMensalidade(props.row,'fev')"
              >FEV</a>
              <a
                class="button is-small"
                :class="generateClassColorStyle(props.row,'mar')"
                @click="gerMensalidade(props.row,'mar')"
              >MAR</a>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <a
                class="button is-small"
                :class="generateClassColorStyle(props.row,'abr')"
                @click="gerMensalidade(props.row,'abr')"
              >ABR</a>
              <a
                class="button is-small"
                :class="generateClassColorStyle(props.row,'mai')"
                @click="gerMensalidade(props.row,'mai')"
              >MAI</a>
              <a
                class="button is-small"
                :class="generateClassColorStyle(props.row,'jun')"
                @click="gerMensalidade(props.row,'jun')"
              >JUN</a>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div><template slot="empty">
        <section class="section">
            <div class="content has-text-grey has-text-centered">
                <p>
                    <b-icon
                        icon="emoticon-sad"
                        size="is-large">
                    </b-icon>
                </p>
                <p>Não há dados para exibir.</p>
            </div>
        </section>
    </template>
              <a
                class="button is-small"
                :class="generateClassColorStyle(props.row,'jul')"
                @click="gerMensalidade(props.row,'jul')"
              >JUL</a>
              <a
                class="button is-small"
                :class="generateClassColorStyle(props.row,'ago')"
                @click="gerMensalidade(props.row,'ago')"
              >AGO</a>
              <a
                class="button is-small"
                :class="generateClassColorStyle(props.row,'set')"
                @click="gerMensalidade(props.row,'set')"
              >SET</a>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <a
                class="button is-small"
                :class="generateClassColorStyle(props.row,'out')"
                @click="gerMensalidade(props.row,'out')"
              >OUT</a>
              <a
                class="button is-small"
                :class="generateClassColorStyle(props.row,'nov')"
                @click="gerMensalidade(props.row,'nov')"
              >NOV</a>
              <a
                class="button is-small"
                :class="generateClassColorStyle(props.row,'dez')"
                @click="gerMensalidade(props.row,'dez')"
              >DEZ</a>
            </div>
          </div>
        </nav>
      </template>

      <template slot="empty">
        <section class="section">
            <div class="content has-text-grey has-text-centered">
                <p>
                    <b-icon
                        icon="emoticon-sad"
                        size="is-large">
                    </b-icon>
                </p>
                <p>Não há dados para exibir.</p>
            </div>
        </section>
      </template>
    </b-table>
  </section>
</template>

<script>
import mensalidade_meses from "@/assets/files/mensalidade_meses.json";
import AddMensalidadeModal from "./components/AddMensalidadeModal";

export default {
  data() {
    return {
      isEmpty: false,
      ano: new Date().getFullYear(),
      idAssociacao: this.$cookies.get("IDASSOCIACAO")
    };
  },
  computed: {
    successAddTransacao() {
      return this.$store.getters["transacao/getIsSuccess"];
    },
    successUpdateSaldoConta() {
      return this.$store.getters["contas/getIsSuccess"];
    },
    successChangeSocioMensalidade() {
      return this.$store.getters["associados/getIsSuccess"];
    }
  },
  methods: {
    gerMensalidade(socio, mesId) {
      let associado = socio.associacoes[`${this.idAssociacao}`];
      let mes = JSON.parse(JSON.stringify(mensalidade_meses[`${mesId}`]));
      mes.data_vencimento = mes.data_vencimento.replace("YYYY", `${this.ano}`);

      if (mes.data_vencimento < associado.data_ingresso) {
        this.$alert(
          "Informação!",
          "Operação não permitida para esse período!",
          "info"
        );
        return;
      }

      let type;
      if (
        associado.mensalidade[`${this.ano}`] &&
        associado.mensalidade[`${this.ano}`][`${mesId}`]
      ) {
        type = "delete";
      } else {
        type = "save";
      }

      if (type == "save") {
        this.$modal.open({
          parent: this,
          component: AddMensalidadeModal,
          hasModalCard: true,
          props: {
            socio: socio,
            mes: mes,
            ano: this.ano
          }
        });
      } else {
        this.$dialog.confirm({
          title: "Apagar Pagamento",
          message: `Clique em 'Ok' para apagar o pagamento da mensalidade de ${
            socio.nome
          } para o mês de ${mes.nome} de ${this.ano}.`,
          onConfirm: () => this.salvarInformacaoPgto(socio, mes)
        });
      }
    },

    /**
     * DELETAR INFORMAÇÕES DA MENSALIDADE
     */
    async salvarInformacaoPgto(socio, mes) {
      const loadingComponent = this.$loading.open({
        container: null
      });

      let associado = socio.associacoes[`${this.idAssociacao}`];
      // console.log(this.$store.getters["transacao/getTransacoes"])

      let transacoes = this.$store.getters["transacao/getTransacoes"].filter(
        transacao => {
          return (
            transacao._id ===
            associado.mensalidade[`${this.ano}`][`${mes._id}`]._transacao
          );
        }
      );

      let transacao = transacoes[0];
      await this.$store.dispatch("transacao/deleteTransacaoInFirestore", transacao);

      if (this.successAddTransacao) {
        this.$alert("Sucesso!", "Transação Removida!", "success");
        this.$store.commit("transacao/setIsSuccess", false);
        await this.$store.dispatch(
          "associados/saveMensalidadeSocioInFirestore",
          {
            socio: socio,
            mes: mes,
            ano: this.ano,
            del: true
          }
        );
      } else {
        this.$alert("Erro!", "Erro ao Salvar Transação!", "danger");
      }
      loadingComponent.close();

      //Notificar usuário da atualização
      if (this.successChangeSocioMensalidade) {
        this.$alert("Sucesso!", "Informação do Usuário Atualizado!", "success");
        this.$store.commit("associados/setIsSuccess", false);
      } else {
        this.$alert("Erro!", "Erro ao Atualizar Informações do Usuário!", "danger");
      }

      this.$store.commit("associacao/setRequireUpdate", true);
      this.$store.dispatch("associacao/getAssociacaoInFirestore");
    },

    verifyStatusPgto(socio) {
      let associado = socio.associacoes[`${this.idAssociacao}`];
      let meses = Object.keys(mensalidade_meses);
      let anos = this.$store.getters["associacao/getAssociacao"].anos_plataforma;
      let anoAtual = new Date().getFullYear();
      let mesAtual = new Date().getMonth();
      let diaAtual = new Date().getDay();
      let ingresso = associado.data_ingresso.split("-"); //[ano, mes] ingresso do sócio na entidade
      ingresso[1]--; //Adequa o mês ao padrão 0 - 11 do Date()

      let result = true;

      anos.forEach(ano => {
        if (anoAtual >= ano && ano >= ingresso[0]) {

          if (!associado.mensalidade[`${ano}`]) {
            result = false;
            return;
          }

          let itrMes = ano == anoAtual ? mesAtual+1 : 12;
          let i = ano == ingresso[0] ? ingresso[1]+1 : 0;

          for (; i < itrMes; i++) {

            if (!(anoAtual == ano && i == mesAtual && diaAtual <= 28)) {
              if (!associado.mensalidade[`${ano}`][`${meses[i]}`]){
                result = false;
                return;
              }
            }
          }
        }
      });
      return result; //Está em dias
    },

    generateClassColorStyle(socio, mesId) {
      let associado = socio.associacoes[`${this.idAssociacao}`];
      let mes = JSON.parse(JSON.stringify(mensalidade_meses[`${mesId}`]));
      mes.data_vencimento = mes.data_vencimento.replace("YYYY", `${this.ano}`);

      if (mes.data_vencimento < associado.data_ingresso)
        return "is-info disabled";

      if (associado.mensalidade[`${this.ano}`]) {
        if (
          associado.mensalidade[`${this.ano}`][`${mesId}`] &&
          associado.mensalidade[`${this.ano}`][`${mesId}`].pago
        )
          return "is-success";
      }

      if (new Date().toISOString() <= mes.data_vencimento) return "is-warning";

      return "is-danger";
    },

    stringRandomId(tamanho) {
      let letras = "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
      let aleatorio = "";
      for (var i = 0; i < tamanho; i++) {
        var rnum = Math.floor(Math.random() * letras.length);
        aleatorio += letras.substring(rnum, rnum + 1);
      }
      return aleatorio;
    },

    toggle(row) {
      this.$refs.table.toggleDetails(row);
    }
  },
  mounted() {
    this.$store.dispatch("associacao/getAssociacaoInFirestore");
    this.$store.dispatch("contas/getContasInFirestore");
    this.$store.dispatch("transacao/getTransacoesInFirestore");
  }
};
</script>

<style>
.disabled {
  cursor: not-allowed;
}
</style>
